import { TableData, TableRowData, TableSort } from 'app/components/table/tabledata';

import { Logistician } from 'app/components/data/core/models/persons/logistician';
import { ServerTableDataSource } from 'app/components/table/data_sources/server-data-source';
import { PFQuery } from 'app/components/data/core/models/base/query';
import { filterDeleted } from 'app/components/access/query';

export class LogisticiansTableData extends TableData {

  constructor() {
    super();

    let columns = [
      new TableRowData({
        key: 'name',
        header: 'USERS.TABLEROW.FULLNAME',
        cell: (logistician: Logistician) => `${ logistician.getName() }`
      }),
      new TableRowData({
        key: 'credentials',
        header: 'USERS.TABLEROW.LOGIN',
        cell: (logistician: Logistician) => `${ logistician.getUser() ? logistician.getUser().getUsername() : ''}`
      }),
    ];
    this.setColumns(columns);

    let sort: TableSort = new TableSort('name','asc');
    let tableDataSource = new ServerTableDataSource('Logistician', ['user']);
    tableDataSource.setDefaultSort(sort);
    tableDataSource.queryModify = function (query: PFQuery): PFQuery {
      return filterDeleted(query);
    };
    tableDataSource.queryFilter = (filter, defaultQuery) => {
      defaultQuery.contains("name", filter);

      let usernameQuery = new PFQuery('User');
      usernameQuery.contains('username', filter);
      let logisticianUsernameQuery = new PFQuery('Logistician');
      logisticianUsernameQuery.matchesQuery('user', usernameQuery);

      return PFQuery.or(defaultQuery, logisticianUsernameQuery);
    };
    this.setProvider(tableDataSource);
  }

  canSortColumn(column) {
    if (column.key !== 'name') {
      return false;
    }
    return super.canSortColumn(column);
  }
}
